import React, { PureComponent, Fragment } from 'react';
import { Progress, Table } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Panel from '../../../../../../shared/components/Panel';
import { getDefaultChartColors } from '../../../../../../shared/helpers';

import{
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_generateRandomAPI,
	_getBuildingPhotos,
	_makeSlugifiedArr,
	_shouldShow,
	_urlToName,
} from '../../../../../../shared/helpers/utils';


const _salesPpsf = (bucket) => {
	if(!bucket || !bucket.ppsf) return 0;
	if(bucket.ppsf.sum_price && bucket.ppsf.sum_sq_ft && bucket.ppsf.sum_sq_ft > 0){
		return bucket.ppsf.sum_price / bucket.ppsf.sum_sq_ft;
	}
	return bucket.ppsf.avg_ppsf && bucket.ppsf.avg_ppsf > 0 ? bucket.ppsf.avg_ppsf : 0;
};

class UnitBreakdown extends PureComponent {


  constructor(props) {
    super(props);
    this.state = {
      x: 0,
      y: 0,
    };
  }

  _generateUnitMixBreakdown = (mixData) => {
	 if(!mixData || !mixData.unit_mix || !mixData.unit_mix.buckets){
		  return [];
	  }
	 const total = mixData.unit_mix.buckets.map(bucket => bucket.count).reduce((accumulator, current) => { return accumulator + current}, 0);
	 let other = 0;
	 let data = mixData.unit_mix.buckets.sort((a, b) =>  a.val - b.val).filter(bucket => bucket.val <=6).map((bucket, i) => {
		 const stat = bucket.non_zero_price ? bucket.non_zero_price : false;
		 const soldStat = bucket.sold_price ? bucket.sold_price : false;
		 return {name: bucket.val > 0 ? `${bucket.val} Bed` : `Studio`,
			 	 bed: bucket.val,
			 	 count:  bucket.count,
			 	 size: bucket.avg_unit_size,
			 	 price: stat.avg_ppsf,
				 sold_price: soldStat && soldStat.avg_ppsf ? soldStat.avg_ppsf : "--",
			 	 carrying_cost: stat.avg_monthly_carrying_charges,
			 	 avg_fees: stat.avg_fees,
			 	 min_price: stat.min_price,
			 	 max_price: stat.max_price,
			 	 color: getDefaultChartColors[i],
			 	 search : bucket.val == 0 ? 'studio' :  bucket.val > 3 ? '4-or-more' :  bucket.val+'-bedroom'
	}
	 });

	 return data;

  }

  _generateSalesPpsfByBed = (salesMix) => {
	 const byBed = {};
	 if(!salesMix) return byBed;
	 [['sponsor', salesMix.sponsor_sales], ['resale', salesMix.resale_sales]].forEach(([type, mix]) => {
		 if(mix && mix.unit_mix && mix.unit_mix.buckets){
			 mix.unit_mix.buckets.forEach(bucket => {
				 if(!byBed[bucket.val]) byBed[bucket.val] = {};
				 byBed[bucket.val][type] = _salesPpsf(bucket);
			 });
		 }
	 });
	 return byBed;
  }
  
  handleClick(e,unit) {
  	
  	const { history, location } = this.props; 
  	const base_url = location.pathname.replace('analysis', 'units');	
  	history.push(`${base_url}?offering_bedrooms=${unit.search}`);

  }

  
  render() {
	const { t, mixData, salesMix } = this.props;
    if(!mixData){
	    return null;
    }
    const data = this._generateUnitMixBreakdown(mixData);
    const showSalesSplit = salesMix && ((salesMix.sponsor_sales && salesMix.sponsor_sales.count > 0) || (salesMix.resale_sales && salesMix.resale_sales.count > 0));
    const salesByBed = showSalesSplit ? this._generateSalesPpsfByBed(salesMix) : {};

	return (
		  <Panel lg={12} xl={12} md={12} sm={12}  xs={12} title={`Unit Breakdown`} className={"pl-0"}>
		    <Table responsive striped className="table--bordered dashboard__audience-table">
		      <thead>
		        <tr>
		          <th>Unit Type</th>
		          <th>Count</th>
		          <th>Avg Size</th>
		          <th>Avg Asking PPSF</th>
				  <th>Avg Sold PPSF</th>
		          <th>Avg CC</th>
		          <th>Range</th>
		        </tr>
		      </thead>
		      <tbody>
		        {data.map(unit =>
		        <tr onClick={(e) => this.handleClick(e, unit)} className="tr__link">
		          <td><span style={{ backgroundColor: unit.color, width:"10px", height:"10px", display:"inline-block" }} /> {unit.name}</td>
		          <td>{unit.count}</td>
		          <td>{unit.size > 0 ? _formatNumber(unit.size) + ' sq ft' : '--'}</td>
		          <td>{unit.price && unit.price > 0 ? `$${_formatNumber(unit.price)}` : '--'}</td>
				  {showSalesSplit ?
				  <td style={{whiteSpace:"nowrap"}}>
					  {salesByBed[unit.bed] && (salesByBed[unit.bed].sponsor > 0 || salesByBed[unit.bed].resale > 0) ?
					  <Fragment>
						  {salesByBed[unit.bed].sponsor > 0 && <div>${_formatNumber(salesByBed[unit.bed].sponsor)} <span className="xsmall-text light-text">(S)</span></div>}
						  {salesByBed[unit.bed].resale > 0 && <div>${_formatNumber(salesByBed[unit.bed].resale)} <span className="xsmall-text light-text">(R)</span></div>}
					  </Fragment>
					  : '--'}
				  </td>
				  :
				  <td>{unit.sold_price && unit.sold_price > 0 ? `$${_formatNumber(unit.sold_price)}` : '--'}</td>
				  }
		          <td>{unit.avg_fees && unit.avg_fees>0 ? <Fragment>${_formatNumber(unit.avg_fees)}<span className="small-text">/mo</span></Fragment> : '--'}</td>
		          <td>
		            {unit.min_price && unit.min_price > 0 ? `${_formatPrice(unit.min_price)} - ${_formatPrice(unit.max_price)}` : '--'}
		          </td>
		        </tr>
		        )}
		      </tbody>
		    </Table>
		  </Panel>
	  )

  }
}

export default UnitBreakdown;
